import type { ElementType, FC } from 'react';
import classNames from 'classnames';

import { t as translate } from './t';

interface Props {
    t: string;
    options?: Record<string, unknown>;
    component?: ElementType;
    id?: string;
    className?: string;
    'data-cy'?: string;
}

const DEFAULT_WRAPPER = 'span';

export const Translation: FC<Props> = ({
    t,
    options,
    component,
    className,
    ...passThroughProps
}) => {
    const translation = translate(t, options);

    if (!component && !className && Object.keys(passThroughProps).length === 0) {
        return <>{translation}</>;
    }

    const Wrapper = component || DEFAULT_WRAPPER;

    const combinedClassName = classNames('Translation', className);

    return (
        <Wrapper className={combinedClassName} {...passThroughProps}>
            {translation}
        </Wrapper>
    );
};
